import dayjs from "dayjs"
import { Button, Card } from "antd"

export interface ISharedVirtualMeetInvitationCardData {
  virtualMeetInvitationId: number
  virtualMeetId: number
  clubId: number
  status: "accepted" | "pending" | "declined"
  meetName: string
  meetdate: string
  startdate: string | null
  course: number
  organizerClubName: string | null
  organizerClubNameLong?: string | null
}

export default function SharedVirtualMeetInvitationCard({
  invitation,
  onReviewInvitation,
  showReviewButton = true,
  reviewButtonLabel = "Review Invitation",
}: {
  invitation: ISharedVirtualMeetInvitationCardData
  onReviewInvitation?: (invitation: ISharedVirtualMeetInvitationCardData) => void
  showReviewButton?: boolean
  reviewButtonLabel?: string
}): JSX.Element {
  const organizerName =
    invitation.organizerClubNameLong || invitation.organizerClubName || null

  const formatCourseLabel = (course: number | null | undefined): string => {
    if (course === 1) return "SCM"
    if (course === 2) return "LCM"
    return "SCY"
  }

  return (
    <Card
      className="shared-virtual-meet-card"
      variant="borderless"
      style={{
        minWidth: 0,
        borderRadius: 5,
        border: "1px solid rgba(0, 0, 0, 0.06)",
        background:
          "linear-gradient(180deg, rgba(240, 247, 255, 0.92) 0%, rgba(255, 255, 255, 0.99) 100%)",
        boxShadow: "0 1px 2px 2px rgba(0, 0, 0, 0.04)",
      }}
      styles={{ body: { padding: "16px 18px" } }}
    >
      <div
        style={{
          borderRadius: 12,
          border: "1px solid rgba(16, 18, 66, 0.08)",
          background:
            "linear-gradient(180deg, rgba(230,244,255,0.45) 0%, rgba(255,255,255,0.98) 100%)",
          padding: 14,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                color: "#595959",
                marginBottom: 4,
              }}
            >
              Pending Invitation
            </div>
            <h3 style={{ margin: "0 0 6px", color: "#101242" }}>{invitation.meetName}</h3>
            <h4
              style={{
                margin: 0,
                fontSize: 13,
                lineHeight: 1.55,
                fontWeight: 400,
                color: "rgba(16, 18, 66, 0.72)",
              }}
            >
              {invitation.startdate ? (
                <span>
                  Meet Window: {dayjs(invitation.startdate).format("MM-DD-YYYY")} to {dayjs(invitation.meetdate).format("MM-DD-YYYY")}
                </span>
              ) : (
                <span>{dayjs(invitation.meetdate).format("MM-DD-YYYY")}</span>
              )}
              <br />
              <span>Virtual Course: {formatCourseLabel(invitation.course)}</span>
              {organizerName ? (
                <span>
                  <br />
                  Organizer: {organizerName}
                </span>
              ) : null}
            </h4>
          </div>
          <div style={{ minWidth: 220 }}>
            <div style={{ fontSize: 12, color: "rgba(16, 18, 66, 0.72)" }}>
              Choose your season roster and pool when you accept this shared virtual meet.
            </div>
            {showReviewButton ? (
              <div style={{ marginTop: 12 }}>
                <Button
                  type="primary"
                  onClick={() => onReviewInvitation?.(invitation)}
                  disabled={!onReviewInvitation}
                >
                  {reviewButtonLabel}
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Card>
  )
}